import "./assets/css/App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import './assets/css/App.css';
import Introduction from "./pages/Introduction";
import PageNotFound from "./pages/PageNotFound";
import Login from "./pages/auth/Login";
import AdminPanel from "./pages/AdminPanel";
import Actualities from "./pages/subpages/Actualities";
import Article from "./pages/subpages/Article";
import PageBuilder from "./components/PageBuilder";
import Concerts from "./pages/subpages/Concerts";
import Recovery from "./pages/auth/Recovery";
import RegistrationEmployee from "./pages/auth/RegistrationEmployee";

function App() {

    return (
        <BrowserRouter>
            <Routes>
                {/*Zakladne*/}
                <Route path="/" element={<Introduction/>}/>
                <Route path="/cd" element={<Introduction/>}/>
                <Route path="/aktuality" element={<Actualities/>}/>
                <Route path="/koncerty" element={<Concerts/>}/>
                <Route path="/aktuality/:article_id" element={<Article/>}/>
                <Route path="/galeria" element={<Introduction/>}/>

                {/*Autorizacia a administracia*/}
                <Route path="/prihlasenie" element={<Login/>}/>
                <Route path="/auth/:uid" element={<RegistrationEmployee/>}/>
                <Route path="/obnovenie&uctu" element={<Recovery/>}/>
                <Route path="/admin" element={<AdminPanel/>}/>
                <Route path="/admin/:adminSection" element={<AdminPanel/>}/>
                <Route path="/admin/aktuality/:articleID" element={<PageBuilder/>}/>
                <Route path="/admin/uprava-clanku/:articleID" element={<PageBuilder/>}/>

                <Route path="*" element={<PageNotFound/>}/>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
